import baseApi from './baseApi';

/************************************************** API **************************************************/
const macrosApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMacros: builder.query({
      query: () => ({
        url: 'macros',
        method: 'GET'
      }),
      transformResponse: (response) => response.data
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useGetMacrosQuery } = macrosApi;
